import { render, staticRenderFns } from "./selectServiceCenter.vue?vue&type=template&id=6ac23b10&scoped=true&"
import script from "./selectServiceCenter.vue?vue&type=script&lang=js&"
export * from "./selectServiceCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac23b10",
  null
  
)

export default component.exports